import React from "react";

export const statusRenderer = (params) => {
  if (!params.value) return null;

  return (
    <span className="missionSpan">
      {params.value === "valid" && (
        <img
          alt="Valid"
          src="https://www.ag-grid.com/example-assets/icons/tick-in-circle.png"
          className="missionIcon"
          title="Case UPC validated successfully"
          style={{ width: '16px', height: '16px' }}
        />
      )}
    </span>
  );
};

export default statusRenderer;
